import { SVC_A } from './base'

export function getCameraConfigForDomain (domainUUID, refresh) {
  const ref = refresh ? '' : '&force_refresh=true'
  return SVC_A.get(`/api/dna/v1/config/camera?domain_uuid=${domainUUID}${ref}`)
}

export function getAlertConfigForDomain (domainUUID, refresh) {
  const ref = refresh ? '&force_refresh=true' : ''
  return SVC_A.get(`/api/dna/v1/config/alert?domain_uuid=${domainUUID}${ref}`)
}

export function getAvailableDetectables (domainUUID) {
  return SVC_A.get(`/api/dna/v1/config/detectable?domain_uuid=${domainUUID}`)
}

export function getNotificationTargetsForDomainAndUser (domainUUID) {
  return SVC_A.get(`/api/dna/v1/config/notification_targets?domain_uuid=${domainUUID}`)
}

export function patchDNAConfig (body) {
  return SVC_A.patch(`/api/dna/v1/config`, body)
}

export function snoozeAlert (body) {
  return SVC_A.post(`/api/dna/v1/notification/snooze`, body)
}
